import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import 'react-tabs/style/react-tabs.css';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';



import PrincipalSettingTable from '../Settings/PrincipalSettingTable';
import GeneralSettingTable from '../Settings/GeneralSettingTable';
import PaymentSettingTable from '../Settings/PaymentSettingTable';
import CostSettingTable from '../Settings/CostSettingTable';
import BondSettingTable from '../Settings/BondSettingTable';
import TransactionKeySettingTable from '../Settings/TransactionKeySettingTable';
import ReturnSettingTable from '../Settings/ReturnSettingTable';
import PointSettingTable from '../Settings/PointSettingTable';
import CollectionFeeSettingTable from '../Settings/CollectionFeeSettingTable';



class SettingsTab extends React.Component {
  state = {
  };

  constructor(props){
    super(props);
  }

  componentDidMount(){
  
  }

  render() {

  
    let claimData = this.props.claimData;
    let result = this.props.result;

    const marginStyle = 
    {
      margin: '5px'
    };
    return (      
        <div className="grid">
        <div className="col s3of12" style={marginStyle}>
          <GeneralSettingTable data={claimData}/>
          <br/>
          {!claimData.bond && <PrincipalSettingTable data={claimData}/>}
          {claimData.bond && <BondSettingTable data={claimData}/>}
          <br/>
          <CollectionFeeSettingTable calculateToDate={this.props.calculateToDate.toDate()} data={claimData} />
        </div>
        <div className="col s8of12">
          <Tabs defaultIndex={0}>
              <TabList>
                <Tab>Færslur með máli</Tab>
                <Tab>Færslulyklar</Tab>                
                <Tab>Töflur</Tab>                
              </TabList>
            <TabPanel>
              <div className="grid">                    
                  <div className="col s4of12" style={marginStyle}>                    
                    <PaymentSettingTable data={claimData}/>            
                  </div>
                  <div className="col s3of12" style={marginStyle}>
                    <CostSettingTable data={claimData}/>            
                  </div>
                  <div className="col s3of12" style={marginStyle}>
                    <ReturnSettingTable data={claimData}/>                                        
                  </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="grid">
                <div className="col">
                  <TransactionKeySettingTable data={claimData}/>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="grid">
                {claimData.penaltyInterests != null && <div className="col" style={marginStyle}>
                  <PointSettingTable title="Dráttavaxta tafla" isPercent={true} hasExtra={false} points={claimData.penaltyInterests[0].penaltyInterestTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="VSK tafla" isPercent={true} hasExtra={false} points={claimData.vatTable}  calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="FTS tafla" isPercent={true} hasExtra={false} points={claimData.capitalGainsTaxTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>
                {claimData.bond &&              
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="Samningsvaxta tafla" isPercent={true} hasExtra={false} points={claimData.bond.legs[0].contractInterests[0].contractInterestTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                {claimData.bond &&              
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="Verðtryggingar tafla" isPercent={false} hasExtra={false} points={claimData.bond.legs[0].indexTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                {claimData.bond &&              
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="Greiðsluseðla tafla" isPercent={true} hasExtra={false} points={claimData.bond.legs[0].slipCostTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                {claimData.bond &&              
                <div className="col" style={marginStyle}>                  
                  <PointSettingTable title="Milliinnheimtu tafla" isPercent={true} hasExtra={false} points={claimData.bond.prelegalCostTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                {claimData.bond &&              
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="Verðbótaþáttur" isPercent={true} hasExtra={true} points={claimData.bond.legs[0].indexationFactorTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>
                </div>}
                {claimData.bond &&              
                <div className="col" style={marginStyle}>
                  <PointSettingTable title="Jöfnunarvísitölu tafla" isPercent={true} hasExtra={true} points={claimData.bond.legs[0].equalizationTable} calculateToDate={this.props.calculateToDate} oldestDueDate={this.props.oldestDueDate}/>          
                </div>}                  
              </div>                  
            </TabPanel>
          </Tabs>
        </div>
      </div>  
    );
  }
}

SettingsTab.propTypes = {    
  claimData : PropTypes.object, 
  result : PropTypes.object, 
  calculateToDate : PropTypes.object,
  oldestDueDate : PropTypes.object
};



export default SettingsTab;




// WEBPACK FOOTER //
// ./src/pages/Calculation/Tabs/SettingsTab.js